<div *ngIf="applymentModel.shouldStopRedirectFromRootUrl">
  <app-initial-page></app-initial-page>
</div>

<div class="rb-container" *ngIf="!applymentModel.shouldStopRedirectFromRootUrl">
  <app-client-main-bar ></app-client-main-bar>

  <mat-sidenav-container class="rb-sidenav-container">
    <mat-sidenav
      #snav
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [style.minWidth.px]="'265'"
      position="end"
      [fixedInViewport]="mobileQuery.matches">
      <app-client-side-nav ></app-client-side-nav>
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
